<script setup lang="ts">
import Translator from "@/utils/common/Translator.ts";
import AboutNama from "@/components/settings/AboutNama.vue";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import {useDialogPluginComponent} from "quasar";

const {dialogRef, onDialogCancel} = useDialogPluginComponent();

</script>
<template>
  <q-dialog ref="dialogRef" transition-show="jump-up" transition-hide="jump-up">
    <div id="about-dialog"
         class=" tw-max-w-xl tw-w-full tw-max-h-screen tw-bg-namaBackground-deep-light dark:tw-bg-namaBackground-bright-dark tw-rounded-[20px]">
      <q-bar
        class="tw-text-xs tw-ring-1 dark:tw-ring-gray-500 tw-ring-gray-200 tw-sticky tw-z-10 tw-top-0 tw-text-namaFontColor-light tw-bg-namaBackground-dim-light dark:tw-bg-namaBackground-deep-dark dark:tw-text-white tw-p-6 tw-pe-2">
        <div class="tw-text-2xl tw-text-primary-light dark:tw-text-primary-dark tw-font-bold"
             v-text="Translator.translateId('about')"/>
        <q-space/>
        <NamaIcon default-icon="close" @click="onDialogCancel" :title="Translator.translateId('close')" class="tw-size-5 tw-cursor-pointer"/>
      </q-bar>
      <div class="tw-max-h-[75vh] tw-overflow-y-auto">
        <AboutNama/>
      </div>
      <div class="tw-pb-2  tw-bg-namaBackground-deep-light dark:tw-bg-namaBackground-bright-dark tw-sticky tw-bottom-0" dir="ltr">
        <a :href="Translator.translateId('appUrl')"
           class="tw-space-x-1  tw-underline tw-text-primary-light dark:tw-text-primary-dark tw-text-center tw-block"
           target="_blank">
          <span v-text="Translator.translateId('appUrl')"/>
          <q-icon name="open_in_new"/>
        </a>
      </div>
    </div>
  </q-dialog>
</template>
